import React from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import styles from "./DisabledWithTooltip.module.scss";

interface Props {
    reason?: string | null;
    children: React.ReactNode;
}

export const DisabledWithTooltip: React.FC<Props> = ({ reason, children }) => {
    if (!reason) {
        return <>{children}</>;
    }

    return (
        <Tooltip content={reason}>
            <div className={styles.wrapper}>{children}</div>
        </Tooltip>
    );
};
